export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
    /** Correlation id from the backend `{code,message,request_id}` envelope
     *  (falls back to the client-generated X-Request-ID). Shown to users as a
     *  copyable support reference. */
    public readonly requestId?: string,
    /** Machine-readable error code from the backend envelope, when present. */
    public readonly code?: string,
    /** Structured reasons an action was refused, from a `{message, blockers}` 409.
     *  Kept as an array as well as being folded into `message`, so a screen can
     *  render one row per blocker — and route each one to the setting that fixes
     *  it — instead of showing a single run-on sentence. */
    public readonly blockers?: readonly string[],
    /** The backend's raw `detail`, for screens that act on its structure (e.g. a 409
     *  listing which rows conflict). Undefined when the body carried none. */
    public readonly detail?: unknown,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export type PaginatedResponse<T> = {
  data: T[];
  total: number;
  page: number;
  pageSize: number;
};
